// extracted by mini-css-extract-plugin
module.exports = {"homematesNeedsList":"styles_homematesNeedsList__1j5PB"};